// Import model
import { StartContactAppointmentSendOmwsmsRequest } from '../models/StartContactAppointmentSendOmwsmsRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartContactAppointmentSendOmwsmsRequest - handles JSON serialization and deserialization with type validation
 */
export class StartContactAppointmentSendOmwsmsRequestSerializer {
  /**
   * Deserializes a JSON string into a StartContactAppointmentSendOmwsmsRequest instance
   */
  static deserialize(json: string): StartContactAppointmentSendOmwsmsRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartContactAppointmentSendOmwsmsRequest instance
   */
  static fromObject(obj: any): StartContactAppointmentSendOmwsmsRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartContactAppointmentSendOmwsmsRequest');
    }


    const instance: StartContactAppointmentSendOmwsmsRequest = {
      phoneNumber: obj['PhoneNumber'] as string | undefined,
      description: obj['Description'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartContactAppointmentSendOmwsmsRequest instances
   */
  static deserializeArray(json: string): StartContactAppointmentSendOmwsmsRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartContactAppointmentSendOmwsmsRequest instance to a JSON string
   */
  static serialize(instance: StartContactAppointmentSendOmwsmsRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartContactAppointmentSendOmwsmsRequest instance to a plain object
   */
  static toObject(instance: StartContactAppointmentSendOmwsmsRequest): any {
    return {
      'PhoneNumber': instance.phoneNumber,
      'Description': instance.description,
    };
  }

  /**
   * Serializes an array of StartContactAppointmentSendOmwsmsRequest instances to a JSON string
   */
  static serializeArray(instances: StartContactAppointmentSendOmwsmsRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
